export const FormProxy = (superClass) => class extends superClass {
	constructor () {
		super();
		this.outerForm = this.closest('form');
		this.outerFormProxy = document.createElement('div');
		this.outerFormProxy.classList.add('u-hidden');
		this.outerForm.appendChild(this.outerFormProxy);
	}

	get innerForm () {
		return this.shadowRoot.querySelector('form');
	}

	updated () {
		super.updated();
		const formData = new FormData(this.innerForm);
		let output = '';

		// eslint-disable-next-line array-element-newline
		for (const [key, value] of formData) {
			output += `<input type="hidden" name="${key}" value="${value}" />`;
		}

		this.outerFormProxy.innerHTML = output;
	}
};
